// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_OFg","cls2":"LoswpTabsHero-cls2_OFb LoswpTabsHero-cls1_OFg"};